<template>
  <ComponentCard title="Labels" icon="solar:tag-linear">
    <div v-for="(item, i) in attrs.items" :key="i" class="flex items-center gap-1">
      <div class="min-w-0 flex-1"><BlockField :model-value="item" placeholder="One or two words" :read-only="readOnly" input-class="text-xs font-bold uppercase tracking-wide text-[#1c4848]" @update:model-value="list.change(i, $event)" /></div>
      <RowActions v-if="!readOnly" :first="i === 0" :last="i === attrs.items.length - 1" @up="list.move(i, -1)" @down="list.move(i, 1)" @remove="list.remove(i)" />
    </div>
    <button v-if="!readOnly" type="button" class="min-h-9 rounded-lg px-2 text-xs font-bold text-[#1c4848]/60 hover:bg-[#1c4848]/5 hover:text-[#1c4848]" @click="list.add('')">+ Add a label</button>
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';
import RowActions from '@/components/writer/views/RowActions.vue';
import { useItems } from '@/components/writer/views/useItems.js';

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
const list = useItems(props);
</script>
